/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import {
  Image,
  Dropdown,
  Icon,
  Input,
  Button,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import './Dropdown.scss';
import Wrapper from 'hoc/Wrapper';

const ReusableDropdown = ({
  options,
  currentOption,
  onChange,
  search,
  setCurrentOption,
  disabled,
  placeholder,
  customstyle,
  customStyleSelector,
  bottomAction,
  actionHandler,
  actionLabel,
}) => {
  const [brokenImages, setBrokenImages] = useState([]);
  const [brokenImages1, setBrokenImages1] = useState(false);

  const handleImageError = index => {
    setBrokenImages(prevBrokenImages => [...prevBrokenImages, index]);
  };

  let name;
  const newOptions =
    options &&
    options?.map(option => {
      // select country
      if (option.Flag && option.CountryName && option.Currency) {
        name = 'CountryCode';
        return {
          ...option,
          Img: option.Flag,
          Title: option.CountryName,
          Currency: option.Currency,
          CountryCode: option.CountryCode,
          PhoneAreaCode: option.PhoneAreaCode,
          BrandUnikID: option.BrandUnikID,
          ShortName: option.ShortName,
          Fields: option.Fields,
          FieldsJson: option.FieldsJson,
          OperatorID: option.OperatorID,
          OperatorName: option.OperatorName,
          PrePaid: option.PrePaid,
          AcceptVoucher: option.AcceptVoucher,
          ActionType: option.ActionType,
        };
      }
      // select phone provider
      if (
        option.OperatorName &&
        option.Logo &&
        option.OperatorID &&
        option.Category
      ) {
        name = 'OperatorName';
        return {
          ...option,
          Title: option.OperatorName,
          Img: option.Logo,
          OperatorID: option.OperatorID, // Duplicate key, consider removing one
          Category: option.Category,
          PhoneAreaCode: option.PhoneAreaCode,
          BrandUnikID: option.BrandUnikID,
          ShortName: option.ShortName,
          ActionType: option.ActionType,
          Fields: option.Fields,
          FieldsJson: option.FieldsJson,
          OperatorName: option.OperatorName,
          PrePaid: option.PrePaid,
          AcceptVoucher: option.AcceptVoucher,
        };
      }
      // select phoneNumber
      if (
        (option.PhonePrefix || option?.Phone) &&
        option.PhoneFlag &&
        option.PhoneNumber &&
        option?.Category
      ) {
        name = 'OperatorName';
        return {
          Title: `+${option?.PhonePrefix || ''} ${
            option?.PhoneNumber
          }`
            .replaceAll('+ +', '+')
            .replaceAll('++', '+'),
          Img: option?.PhoneFlag,
        };
      }
      // select wallet
      if (
        option.AccountNumber &&
        option.AccountName &&
        option.CurrencyCode &&
        option.WalletQRCode
      ) {
        return {
          Title: `${option.AccountNumber} (${option.AccountName})`,
          Img: option.Flag,
          CurrencyCode: option.CurrencyCode,
          AccountNumber: option.AccountNumber,
          WalletQRCode: option.WalletQRCode,
          Balance: option.Balance,
        };
      }
      // Select provider

      if (option.SupplierID && option.ShortName) {
        return {
          ...option,
          Title: option.Name,
          Img: option.Logo,
          CountryCode: option.CountryCode,
          SupplierID: option.SupplierID,
          Name: option.Name,
        };
      }
      if (option.Img && option.Title) {
        return option;
      }

      // select bank account

      if (option.BankCode && option.BankLogo) {
        return {
          ...option,
          Title: option.AccountNumber ?? option.BankName,
          Img: option.BankLogo,
          CurrencyCode: option.Currency,
          OperatorName: option.BankName,
          PhoneAreaCode: option.PhoneAreaCode,
          BrandUnikID: option.BrandUnikID,
          ShortName: option.ShortName,
          ActionType: option.ActionType,
          Fields: option.Fields,
          FieldsJson: option.FieldsJson,
          OperatorID: option.OperatorID,
          OperatorName: option.OperatorName,
          PrePaid: option.PrePaid,
          AcceptVoucher: option.AcceptVoucher,
        };
      }

      // select bank name

      if (
        option.BankCode &&
        option.Logo &&
        option.BankName &&
        !option.AccountNumber
      ) {
        return {
          ...option,
          Title: option.BankName,
          Img: option.Logo,
        };
      }
    });
  let newCurrentOption;
  if (currentOption && currentOption.OperatorID) {
    newCurrentOption = {
      ...currentOption,
      Title: currentOption.OperatorName || currentOption.Title,
      Img: currentOption.Logo || currentOption.Img,
      OperatorID: currentOption.OperatorID,
      Category: currentOption.Category,
    };
  } else if (currentOption && currentOption.CountryName) {
    newCurrentOption = {
      ...currentOption,
      Title: currentOption.CountryName,
      Img: currentOption.Flag,
      Currency: currentOption.Currency,
      CountryCode: currentOption.CountryCode,
      PhoneAreaCode: currentOption.PhoneAreaCode,
    };
  } else if (
    currentOption?.AccountName &&
    currentOption?.Default &&
    currentOption?.AccountNumber &&
    currentOption?.WalletQRCode
  ) {
    newCurrentOption = {
      Title: currentOption.AccountNumber,
      Img: currentOption.Flag,
      CurrencyCode: currentOption.CurrencyCode,
    };
  } else {
    newCurrentOption = currentOption;
  }

  const wrapperId = `input-${Math.ceil(Math.random() * 10000)}`;
  const [filteredOptions, setFilteredOptions] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (newOptions) {
      setFilteredOptions(newOptions);
    }
  }, [options]);
  const checkClickInput = event => {
    const { target = {} } = event || {};
    if (target.classList && target.id === wrapperId) {
      return setOpen(false);
    }
    return null;
  };

  useEffect(() => {
    document.addEventListener('mousedown', checkClickInput);
    return () => {
      document.removeEventListener('mousedown', checkClickInput);
    };
  });

  useEffect(() => {
    const handleBrokenImages = async () => {
      if (!filteredOptions) return;

      const promises = filteredOptions.map((option, index) => {
        if (!option?.Img) return Promise.resolve(true);
        return;
      });

      const results = await Promise.all(promises);
      const brokenImageIndices = results.reduce(
        (acc, isBroken, index) => {
          if (isBroken) acc.push(index);
          return acc;
        },
        [],
      );

      setBrokenImages(brokenImageIndices);
    };

    handleBrokenImages();
  }, [filteredOptions]);

  return (
    <>
      <div
        id={wrapperId}
        style={{
          display: open ? 'block' : 'none',
          background: 'transparent',
          width: '100%',
          height: '100%',
          position: 'fixed',
          top: '0',
          left: '0',
        }}
      />

      <Dropdown
        placeholder="Select"
        id={wrapperId}
        disabled={disabled}
        style={{ maxWidth: customStyleSelector ? '100%' : 'auto' }}
        className="custom-dropdown"
        open={open}
        trigger={
          <span
            className="dropdown-trigger"
            onClick={() => setOpen(!open)}
            tabIndex={-1}
            onKeyDown={() => setOpen(!open)}
            role="button"
          >
            <div className="dropdown-wallet">
              {!newCurrentOption ? (
                <span>{placeholder}</span>
              ) : (
                <Wrapper>
                  {brokenImages1 === true ? (
                    <div className="orval-shape">
                      <span className="label">
                        {`${newCurrentOption.Title}`.charAt(0)}
                        {`${newCurrentOption.Title}`
                          .charAt(1)
                          .toUpperCase()}
                      </span>
                    </div>
                  ) : (
                    <Image
                      src={newCurrentOption && newCurrentOption.Img}
                      className="inline"
                      onError={e => setBrokenImages1(true)}
                    />
                  )}
                  <div>
                    <div>
                      {newCurrentOption && newCurrentOption.Title}
                    </div>
                  </div>
                </Wrapper>
              )}
            </div>
            {!disabled && (
              <Icon name="caret down" className="inline" />
            )}
          </span>
        }
        icon={null}
      >
        <Dropdown.Menu
          style={{
            width: customstyle ? 'auto' : '100%',
            maxWidth: customstyle ? 'auto' : '100%',
          }}
        >
          {search && (
            <Input
              tabIndex={0}
              icon="search"
              autoFocus
              iconPosition="left"
              onChange={({ target: { value } }) => {
                setFilteredOptions(
                  newOptions?.filter(option =>
                    option?.Title.toLowerCase().includes(
                      value.toLowerCase(),
                    ),
                  ),
                );
              }}
            />
          )}
          <Dropdown.Menu scrolling search={search}>
            {filteredOptions?.map(
              (option, index) =>
                option !== undefined && (
                  <Dropdown.Item
                    key={option.id}
                    onClick={() => {
                      setOpen(false);
                      setBrokenImages1(false);
                      onChange({
                        target: {
                          name,
                          value: option?.BankCode ?? option?.Title,
                        },
                      });
                      setCurrentOption({
                        ...option,
                      });
                    }}
                  >
                    <span className="dropdown-trigger">
                      <div className="dropdown-wallet">
                        {brokenImages.includes(index) ? (
                          <div className="orval-shape">
                            <span className="label">
                              {(() => {
                                let name = option?.ShortName || option?.Title || option?.OperatorName || '';
                                if (name === 'N/A' || name === 'NA' || name.toLowerCase() === 'null') {
                                  name = option?.Title || option?.OperatorName || '';
                                }
                                if (!name) return 'SP';
                                const clean = name.trim();
                                return clean.length >= 2
                                  ? (clean.charAt(0) + clean.charAt(1)).toUpperCase()
                                  : clean.toUpperCase();
                              })()}
                            </span>
                          </div>
                        ) : (
                          <Image
                            src={option?.Img}
                            className="inline"
                            onError={() => handleImageError(index)}
                          />
                        )}
                        <div>
                          <div>{option?.Title}</div>
                        </div>
                      </div>
                    </span>
                  </Dropdown.Item>
                ),
            )}
          </Dropdown.Menu>
          {bottomAction === true && actionLabel?.length && (
            <Button
              className="dropdown__button"
              onClick={actionHandler}
              basic
            >
              <Icon disabled name="add" />
              {actionLabel || global.translate('Add')}
            </Button>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

ReusableDropdown.defaultProps = {
  options: [{}],
  currentOption: undefined,
  onChange: () => null,
  search: false,
  setCurrentOption: () => {},
  disabled: false,
  placeholder: '',
  customstyle: false,
  customStyleSelector: false,
  bottomAction: PropTypes.bool,
  actionLabel: PropTypes.string,
  actionHandler: PropTypes.func,
};

ReusableDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  currentOption: PropTypes.instanceOf(Object),
  onChange: PropTypes.func,
  search: PropTypes.bool,
  setCurrentOption: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  customstyle: PropTypes.bool,
  customStyleSelector: PropTypes.bool,
  bottomAction: false,
  actionLabel: '',
  actionHandler: () => {},
};

export default ReusableDropdown;
